var exports = {
  "k": "VoiceParticipantsList.module__container___LTZNbX",
  "O": "VoiceParticipantsList.module__containerOver___LTZNbX",
};

module.exports = exports;
